import script from "./groupGlory.vue?vue&type=script&setup=true&lang=js"
export * from "./groupGlory.vue?vue&type=script&setup=true&lang=js"

import "./groupGlory.vue?vue&type=style&index=0&id=a969103a&lang=less&scoped=true"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a969103a"]])

export default __exports__